import { apiClient } from './client';

export interface Draft {
  id: string;
  userId: string;
  channelId: string | null;
  peerUserId: string | null;
  content: string;
  replyToId: string | null;
  updatedAt: string;
}

export const draftsApi = {
  async list(): Promise<Draft[]> {
    const res = await apiClient.get<Draft[]>('/api/drafts');
    return res.data;
  },
  async upsert(payload: {
    channelId?: string;
    peerUserId?: string;
    content: string;
    replyToId?: string;
  }): Promise<Draft | null> {
    const res = await apiClient.put<Draft | null>('/api/drafts', payload);
    return res.data;
  },
  async clear(payload: { channelId?: string; peerUserId?: string }): Promise<void> {
    await apiClient.delete('/api/drafts', { params: payload });
  },
};
